export class CountryDto {
    countryId?: number;
    countryName: string;
    createdUser:string;
    isActive: boolean;
    constructor(countryId:number,countryName:string,createdUser:string,isActive:boolean){
        this.countryId = countryId;
        this.countryName = countryName;
        this.createdUser =createdUser;
        this.isActive = isActive;
    }
}

export const CountryDtoDefault : CountryDto = {
    countryId: 0,
    countryName: "",
    createdUser:"",
    isActive:true,
};

